<div class="package-card">
  <div class="package-card__header">
    <div class="package-card__title">
      <div class="package-card__icon">
        <app-cube-01 stroke="#414651" width="20px" height="20px"></app-cube-01>
      </div>
      <span class="text-xl-semibold text-gray-900">{{ name() }}</span>
    </div>
    @if (isPopular()) {
      <span class="package-card__badge text-sm-semibold">
        <app-stars-02 stroke="#FFFFFF" width="14px" height="14px"></app-stars-02>
        Popularan
      </span>
    } @else if (isLastMinuteOnly()) {
      <span class="package-card__badge package-card__badge--last-minute text-sm-semibold">
        <app-clock stroke="#FFFFFF" width="14px" height="14px"></app-clock>
        Samo kroz Last-Minute
      </span>
    }
  </div>

  <div class="package-card__price">{{ formatPrice(price()) }}€</div>

  <div class="package-card__hours">
    Uključuje <strong>{{ hours() }}h</strong> za korišćenje
  </div>

  <!-- One line on every card, so the buttons and "Detalji paketa" line up across the row. -->
  <div class="package-card__rate">
    <div class="package-card__rate-row">
      <app-currency-euro-circle stroke="#7E838F" width="20px" height="20px"></app-currency-euro-circle>
      <span>
        {{ formatPrice(pricePerHour()) }}€ po satu
        @if (savings() > 0) {
          <span class="package-card__savings">• Uštedi do {{ formatPrice(savings()) }}€</span>
        }
      </span>
    </div>
  </div>

  <app-button
    class="package-card__cta"
    [btnSeverity]="ButtonSeverity.PRIMARY"
    [btnSize]="ButtonSize.LG"
    [isBtnDisabled]="isDisabled() || isBusy()"
    (btnClicked)="orderClicked.emit()"
  >
    @if (isBusy()) {
      <i class="pi pi-spin pi-spinner"></i>
    }
    <span class="text-md-semibold text-white">Poruči paket</span>
  </app-button>

  <hr class="package-card__divider" />

  @for (section of sections(); track section.title) {
    <div class="package-card__section">
      <div class="package-card__section-title">{{ section.title }}</div>
      <ul class="package-card__list">
        @for (item of section.items; track item) {
          <li>
            <app-check stroke="#17B26A" width="14px" height="14px"></app-check>
            <span>{{ item }}</span>
          </li>
        }
        <!-- Restrictions / charges: neutral info icon, not a benefit check. -->
        @for (rule of section.rules ?? []; track rule) {
          <li class="package-card__rule">
            <app-info-circle stroke="#7E838F" width="14px" height="14px"></app-info-circle>
            <span>{{ rule }}</span>
          </li>
        }
      </ul>
    </div>
  }
</div>
